import axios from 'axios'
import { environment } from '../environment'

//set up our base environment for our webflicks connection
export const project2BaseUrl = axios.create({
    baseURL:environment.project2BaseUrl, //the base network address with no URI's on 
    withCredentials:true
})

export const project2Scrapper = axios.create({
    baseURL:environment.project2Scrapper, //the base network address with no URI's on 
    withCredentials:true
})